import { render, staticRenderFns } from "./IndexSwiper.vue?vue&type=template&id=c2c84e86&scoped=true&"
import script from "./IndexSwiper.vue?vue&type=script&lang=js&"
export * from "./IndexSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c84e86",
  null
  
)

export default component.exports